import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import Helmet from 'react-helmet'
import { Route } from 'react-router-dom'
import { withTranslation } from 'react-i18next'

import firstScreen from '../../redux/stores/firstScreen/firstScreenAction'
import RenderFirstScreen from './elements/firstScreen/RenderFirstScreen'
import RenderSecondScreen from './elements/secondScreen/renderSecondScreen'
import OrderStatus from './elements/Order/orderStatus'
import CardPhoto from './elements/CardPhoto/cardPhoto'


import SFRegular from '../../fonts/sf_ui_display_regular.ttf'
import SFBold from '../../fonts/SFUIDisplay-Bold.ttf'
import SFHeavy from '../../fonts/SFUIDisplay-Heavy.ttf'
import SFMedium from '../../fonts/SFUIDisplay-Medium.ttf'
import SFSemibold from '../../fonts/SFUIDisplay-Semibold.ttf'
import MBold from '../../fonts/Montserrat-Bold.ttf'
import MExtraBold from '../../fonts/Montserrat-ExtraBold.ttf'
import MMedium from '../../fonts/Montserrat-Medium.ttf'
import MSemibold from '../../fonts/Montserrat-SemiBold.ttf'


const Exchanger = () => {
    const state = useSelector(state => state.firstScreen)

    useEffect(() => {
        firstScreen()
    }, [])

    // console.log(state)

    return (
        <>
            <Helmet>
                <link rel={"preload"} href={SFRegular} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFBold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFHeavy} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFSemibold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={SFMedium} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MBold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MExtraBold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MSemibold} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
                <link rel={"preload"} href={MMedium} as={"font"} type={"font/ttf"} crossOrigin={"anonymous"} />
            </Helmet>
            <Route exact path='/' component={RenderFirstScreen} />
            <Route path='/pre-check' component={RenderSecondScreen} />
            <Route path='/order-status' component={OrderStatus} />
            <Route path="/card-photo" component={CardPhoto} />
        </>
    )
}

export default withTranslation()(Exchanger)